export const guidance: string = `公演実施の為、以下の新型コロナウィルス感染拡大予防対策を実施しております。
また今後、新型コロナウイルスに限らず感染症の急拡大が生じ、政府や自治体から事業者に対する注意喚起等が行われた際は、ガイドラインに応じて更なる感染対策の強化をお願いする場合がございます。お客様にはご不便をおかけしますが、安全な公演実施のため、ご理解とご協力を賜りますよう何卒よろしくお願いいたします。

【お客様へのお願い】
1. 入場時
・以下のいずれかに該当される方はご入場をお断りさせていただきます。
□発熱等、体調不良の症状がある。
□新型コロナウイルス陽性判定を受け、保健所等により定められる療養期間が経過していない。
□過去5日以内に新型コロナウイルス陽性判定を受けた者との濃厚接触がある。(保健所等による特定のほか、事業所等からの周知や自主的な判断によるものを含む)

2. 公演中
・マスクの着用を推奨しております。
・咳エチケットを遵守ください。
・こまめな手洗い・手指消毒にご協力ください。
・お客様同士の距離の確保にご協力ください。
・通路での観覧、公演中の席の移動しての観覧はおやめ下さい。
・入待ち、出待ち等は禁止とさせていただきます。
・ご観覧中体調が悪化するなどの変化を感じたり気分が優れない場合は、お近くのスタッフまで直ちにお申し出ください。
・祝花（スタンド花・アレンジメント花・鉢花等）につきましては、会場スペースの都合上、ファンの皆さまからのご送付は受け付けておりません。ご理解賜りますようお願い申し上げます。`;
